import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "./SplitNumber";
import AddToBasketButton from "./addToBasketButton";
import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "./addToBasketRoundedButton";
function CardTile({
  itemImgSrc,
  amusementUrl,
  amusementName,
  amusementPrice,
  amusementFinalPrice,
  handleClick,
}) {
  return isMobile ? (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center  h-100">
        <Card.Img
          variant="top"
          src={itemImgSrc + "?width=200"}
          className="rounded-3"
        />
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-normal">{amusementName}</h3>
          <Card.Text className="text-black-06 ">
            {amusementFinalPrice > amusementPrice ? (
              <>
                <span className=" text-decoration-line-throught-rotate border-secondary">
                  <SplitNumber number={amusementFinalPrice} />
                </span>
                <span>تومان</span>
              </>
            ) : (
              ""
            )}
          </Card.Text>
        </Card.Body>
        <Card.Footer className="border-top-0 p-0 pt-2 bg-white">
          <AddToBasketButton onClick={handleClick} price={amusementPrice} />
        </Card.Footer>
      </Card>
    </Link>
  ) : (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center  h-100">
        <Card.Img
          variant="top"
          src={itemImgSrc + "?width=210"}
          className="rounded-3"
        />
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-normal pb-3">{amusementName}</h3>

          {/* <AddToBasketButton
            
            price={amusementFinalPrice}
          /> */}
        </Card.Body>
        <Card.Footer className="bg-white p-0 pt-2">
          {" "}
          <Row className="gx-0">
            <Col className="my-auto">
              {amusementFinalPrice > amusementPrice ? (
                <>
                  <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                    <SplitNumber number={amusementFinalPrice} />
                  </span>
                  <span className="fs-08 ps-1">تومان</span>
                </>
              ) : (
                ""
              )}
              <div className="fw-bold text-black">
                <span className=" text-dark pe-1">
                  <SplitNumber number={amusementPrice} />
                </span>
                تومان
              </div>
            </Col>
            <Col xs="auto" className="my-auto">
              <AddToBasketRoundedButton onClick={handleClick} />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </Link>
  );
}
export default CardTile;
